import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import useAuthenticated from '../Dashboard/useAuthenticated';
import GridTable from '../../Components/Table/GridTable';
import { usePaginations } from '../../Hooks/usePaginations';
import { TextInput } from '../../Components/Inputs/TextInput';
import { TextArea } from '../../Components/Inputs/TextArea';
import { Button } from '../../Components/Buttons';
import { useRefresh } from '../../Hooks/useRefresh';
import Modal from '../../Components/Modal';
import { TrashIcon } from '@heroicons/react/24/outline';
import { decompressData } from '../../Utils';
import { ActionTypes } from '../../Store/Stores/User';
import { CustomField } from '../Contacts/Contact';

export default function AdminClientConnection() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const appState = useAppState();
    const user = appState.user;
    const [open, setOpen] = useState(false);
    const [globalVariables, setGlobalVariables] = useState([]);
    const { refreshId, refresh } = useRefresh();
    const [email, setEmail] = useState('');
    const [logLines, setLogLines] = useState('100');
    const [logs, setLogs] = useState('');
    const [loadingLogs, setLoadingLogs] = useState(false);

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    const handleConnect = async () => {
        try {
            const response = await api.login(email, 'admin');
            
            // Dispatch successful login action
            dispatch({ 
                type: ActionTypes.LOGIN, 
                payload: response.data
            });

            window.location.href = '/dashboard';
        } catch (error) {
        } finally { }
    }

    const handleExportLogs = async () => {
        setLoadingLogs(true);
        try {
            const response = await api.getLogs(logLines);
            setLogs(response.data.logs || '');
        } catch (error) {
            setLogs(error.data?.message || error.message || String(error));
        } finally {
            setLoadingLogs(false);
        }
    }


    return (
        <>

        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="admin" />

                        <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                            <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                                <div className='flex flex-row justify-between'>
                                    <div>
                                        <h3 className='text-2xl font-bold'>{translate('setting.admin.title')}</h3>
                                        <p className='text-md text-gray-500 max-w-4xl'>{translate('setting.admin.description')}</p>
                                    </div>
                                </div>
                                <div className='flex flex-col mt-8 pr-8 max-w-md'>
                                    <TextInput label={translate('setting.admin.clientConnection.email')} placeholder={translate('setting.admin.clientConnection.email_placeholder')} value={email} onChange={(e) => setEmail(e.target.value)} />
                                    <div className='flex flex-row justify-end mt-2'>
                                        <Button onClick={handleConnect}>{translate('setting.admin.clientConnection.connect')}</Button>
                                    </div>
                                </div>

                                <div className='mt-8 border-t border-gray-200 pt-6 pr-8'>
                                    <h3 className='text-lg font-bold'>{translate('setting.admin.logs.title')}</h3>
                                    <p className='text-md text-gray-500 max-w-4xl mt-1'>{translate('setting.admin.logs.description')}</p>
                                    <div className='flex flex-col mt-4 max-w-md'>
                                        <TextInput type="number" id="log_lines" name="log_lines" label={translate('setting.admin.logs.lines')} placeholder={translate('setting.admin.logs.lines_placeholder')} value={logLines} onChange={(e) => setLogLines(e.target.value)} />
                                        <div className='flex flex-row justify-end mt-2'>
                                            <Button onClick={handleExportLogs} disabled={loadingLogs}>{loadingLogs ? translate('setting.admin.logs.exporting') : translate('setting.admin.logs.export')}</Button>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <TextArea key={logs} id="logs_result" name="logs_result" label={translate('setting.admin.logs.result')} value={logs || translate('setting.admin.logs.empty')} rows={16} className="font-mono text-xs !bg-gray-50 border !border-gray-200" />
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                
            </SidebarNav>
        </div>
        </>
    );
}
